<p-toast key="emision"></p-toast>

<div style="display: flex; justify-content: space-between; align-items: center;">
  <div style="flex: 1; padding-right: 10px;">
    <div [ngStyle]="{
    'background-color': 'var(--color-seccion, #28a745)',
    'color': 'var(--color-texto, white)',
    'height': '35px',
    'font-weight': '500',
    'display': 'flex',
    'align-items': 'center',
    'padding-left': '20px',
    'margin': '0px 0 20px 0',
    'border-radius': '0px',
    'width': '100%'
}">Datos Adicionales</div>
  </div>
</div>

<form [formGroup]="group_emision">
  <div class="a-example-full-width-alterno-content-column">
    <div class="a-example-full-width-alterno-content-row">
      <div class="a-example-full-width-alterno-content-2">
        <p-floatlabel class="w-full md:w-56 bold-floatlabel textarea-fix" variant="on">
          <textarea inputId="shipper" [ngClass]="{ readonly: btns_habilitados, 'p-filled': true }" rows="5" pTextarea
            formControlName="shipper" style="width: 100%" class="w-full md:w-56" pSize="small"
            placeholder="‎ "></textarea>
          <label for="shipper" style="background: white; padding: 0 4px;">Shipper</label>
        </p-floatlabel>
      </div>
      <div class="a-example-full-width-alterno-content-2">
        <p-floatlabel class="w-full md:w-56 bold-floatlabel textarea-fix" variant="on">
          <textarea inputId="notify" [ngClass]="{ readonly: btns_habilitados, 'p-filled': true }" rows="5" pTextarea
            formControlName="notify" style="width: 100%" class="w-full md:w-56" pSize="small"
            placeholder="‎ "></textarea>
          <label for="notify" style="background: white; padding: 0 4px;">Notify</label>
        </p-floatlabel>
      </div>
    </div>

    <div class="a-example-full-width-alterno-content-row">
      <div class="a-example-full-width-alterno-content-2">
        <p-floatlabel class="w-full md:w-56 bold-floatlabel textarea-fix" variant="on">
          <textarea inputId="consignee" [ngClass]="{ readonly: btns_habilitados, 'p-filled': true }" rows="5" pTextarea
            formControlName="consignee" style="width: 100%" class="w-full md:w-56" pSize="small"
            placeholder="‎ "></textarea>
          <label for="consignee" style="background: white; padding: 0 4px;">Consignee</label>
        </p-floatlabel>
      </div>
      <div class="a-example-full-width-alterno-content-2">
        <p-floatlabel class="w-full md:w-56 bold-floatlabel textarea-fix" variant="on">
          <textarea inputId="applyto" [ngClass]="{ readonly: btns_habilitados, 'p-filled': true }" rows="5" pTextarea
            formControlName="applyto" style="width: 100%" class="w-full md:w-56" pSize="small"
            placeholder="‎ "></textarea>
          <label for="applyto" style="background: white; padding: 0 4px;">Apply To</label>
        </p-floatlabel>
      </div>
    </div>

    <div class="a-example-full-width-alterno-content-row">
      <div class="a-example-full-width-alterno-content-2">
        <p-floatlabel class="w-full" variant="on">
          <input pInputText formControlName="place_receipt" [readonly]="btns_habilitados" class="w-full" pSize="small"
            placeholder="‎ " />
          <label>Place of receipt</label>
        </p-floatlabel>
      </div>
      <div class="a-example-full-width-alterno-content-2">
        <p-floatlabel class="w-full" variant="on">
          <input pInputText formControlName="place_delivery" [readonly]="btns_habilitados" class="w-full" pSize="small"
            placeholder="‎ " />
          <label>Place of Delivery</label>
        </p-floatlabel>
      </div>
    </div>
  </div>
</form>

<div style="display: flex; justify-content: space-between; align-items: center;">
  <div style="flex: 1; padding-right: 10px;">
    <div [ngStyle]="{
    'background-color': 'var(--color-seccion, #28a745)',
    'color': 'var(--color-texto, white)',
    'height': '35px',
    'font-weight': '500',
    'display': 'flex',
    'align-items': 'center',
    'padding-left': '20px',
    'margin': '0px 0 20px 0',
    'border-radius': '0px',
    'width': '100%'
}">Datos Documento Master</div>
  </div>
</div>

<form [formGroup]="group_master">
  <div class="a-example-full-width-alterno-content-column">

    <div class="a-example-full-width-alterno-content-row">
      <div class="a-example-full-width-alterno-content-2">

        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
          <p-select inputId="shipper" [options]="listaShippers" placeholder="‎ " optionLabel="nombre"
            formControlName="shipper" optionValue="codigo" appendTo="body" [filter]="true" [showClear]="true"
            styleClass="w-full md:w-56" virtualScroll="true" virtualScrollItemSize="36" size="small"
            (onChange)="onChangeShipperMbl()">
          </p-select>
          <label for="shipper">Shipper</label>
        </p-floatlabel>
        <!-- <p-button icon="pi pi-replay" size="small" variant="outlined"
          (onClick)="actualizarListaEntidad(10,this.ListaTodosShipper,'Shipper')" styleClass="h-full"></p-button> -->

      </div>
      <div class="a-example-full-width-alterno-content-2">
        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
          <p-select inputId="notify" [options]="listaNotify" placeholder="‎ " optionLabel="nombre"
            formControlName="notify" optionValue="codigo" appendTo="body" [filter]="true" [showClear]="true"
            styleClass="w-full md:w-56" virtualScroll="true" virtualScrollItemSize="36" size="small"
            (onChange)="onChangeNotifyMbl()">
          </p-select>
          <label for="notify">Notify</label>
        </p-floatlabel>
      </div>
    </div>

    <div class="a-example-full-width-alterno-content-row">
      <div class="a-example-full-width-alterno-content-2">
        <p-floatlabel class="w-full md:w-56 bold-floatlabel textarea-fix" variant="on">
          <textarea inputId="desc_shipper" [ngClass]="{ readonly: btns_habilitados, 'p-filled': true }" rows="5"
            pTextarea formControlName="desc_shipper" style="width: 100%" class="w-full md:w-56" pSize="small"
            placeholder="‎ "></textarea>
          <label for="desc_shipper" style="background: white; padding: 0 4px;">Shipper</label>
        </p-floatlabel>
      </div>
      <div class="a-example-full-width-alterno-content-2">
        <p-floatlabel class="w-full md:w-56 bold-floatlabel textarea-fix" variant="on">
          <textarea inputId="desc_notify" [ngClass]="{ readonly: btns_habilitados, 'p-filled': true }" rows="5"
            pTextarea formControlName="desc_notify" style="width: 100%" class="w-full md:w-56" pSize="small"
            placeholder="‎ "></textarea>
          <label for="desc_notify" style="background: white; padding: 0 4px;">Notify</label>
        </p-floatlabel>
      </div>
    </div>

    <div class="a-example-full-width-alterno-content-row">
      <div class="a-example-full-width-alterno-content-2">

        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
          <p-select inputId="consignee" [options]="listaConsignee" placeholder="‎ " optionLabel="nombre"
            formControlName="consignee" optionValue="codigo" appendTo="body" [filter]="true" [showClear]="true"
            styleClass="w-full md:w-56" virtualScroll="true" virtualScrollItemSize="36" size="small"
            (onChange)="onChangeConsigneeMbl()">
          </p-select>
          <label for="consignee">Consignee</label>
        </p-floatlabel>

      </div>
      <div class="a-example-full-width-alterno-content-2">

      </div>
    </div>


    <div class="a-example-full-width-alterno-content-row">
      <div class="a-example-full-width-alterno-content-2">
        <p-floatlabel class="w-full md:w-56 bold-floatlabel textarea-fix" variant="on">
          <textarea inputId="desc_consignee" [ngClass]="{ readonly: btns_habilitados, 'p-filled': true }" rows="5"
            pTextarea formControlName="desc_consignee" style="width: 100%" class="w-full md:w-56" pSize="small"
            placeholder="‎ "></textarea>
          <label for="desc_consignee" style="background: white; padding: 0 4px;">Consignee</label>
        </p-floatlabel>
      </div>
      <div class="a-example-full-width-alterno-content-2">

      </div>
    </div>

  </div>
</form>

<div [ngStyle]="{
    'background-color': 'var(--color-seccion, #28a745)',
    'color': 'var(--color-texto, white)',
    'height': '35px',
    'font-weight': '500',
    'display': 'flex',
    'align-items': 'center',
    'padding-left': '20px',
    'margin': '10px 0 20px 0',
    'border-radius': '0px',
    'width': '100%'
}" style="margin-top: 15px;">Detalles de Contenedores</div>
<div class="a-example-full-width-alterno-content">
  <app-datatable #dtContenedores [dataTable]="dt_contenedores" [metadataTable]="mt_contenedores" [filter]="false"
    [addRow]="true" [colorBtnMas]="true" [rowEdit]="true" [colorBtnEdit]="true" [rowDelete]="true" [colorBtnDel]="true"
    [key]="'key'" [resaltarCabecera]="true" [lineasTabla]="true" [disableAddRow]="bloqueoBtns"
    [disableDeleteRow]="bloqueoBtns" [disableEditRow]="bloqueoBtns" [btnEditAdelante]="true"
    [customButtons]="custombContenedores" [style]="estilos">
  </app-datatable>
</div>

@if(popUpAuditoriaContenedores){
<p-dialog *ngIf="popUpAuditoriaContenedores" [(visible)]="popUpAuditoriaContenedores"
  header="Resultado de la Auditoría - Orden de Venta Detalle Contenedores" appendTo="body" [style]="{width: '80vw'}">
  <div class="a-w1-column">
    <div class="a-w1-row">
      <app-datatable [dataTable]="dt_auditoriaContenedores" [metadataTable]="mt_auditoriaContenedores"
        [customButtons]="custombAuditoriaContenedores">
      </app-datatable>
    </div>
  </div>
</p-dialog>
}